import React, { useState, useEffect } from "react";
import axios from "axios";
import { message } from "antd";
import { InputItem, InputNumberItem, ModalItem } from "../../../../../Components/Items";

const valoresIniciales = { codigo: "", nombre: "", numeroColumnas: 1, numeroNiveles: 1, numeroProfundidades: 1 };

const ModalAgregarRack = ({ visible, onClose, empresaId, proyectoId, mapaAlmacenId, headersToken, onCreado }) => {
  const [valores, setValores] = useState(valoresIniciales);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    if (visible) setValores(valoresIniciales);
  }, [visible]);

  const actualizar = (cambios) => setValores((prev) => ({ ...prev, ...cambios }));

  const crear = async () => {
    if (!valores.codigo) {
      message.warning("Captura un código para el rack");
      return;
    }
    setGuardando(true);
    try {
      const res = await axios.post(
        "rack/agregarRack",
        {
          empresaId,
          proyectoId,
          mapaAlmacenId,
          codigo: valores.codigo,
          nombre: valores.nombre,
          x: 60,
          y: 60,
          ancho: 70,
          alto: 70,
          numeroColumnas: valores.numeroColumnas,
          numeroNiveles: valores.numeroNiveles,
          numeroProfundidades: valores.numeroProfundidades,
        },
        { headers: headersToken }
      );
      if (res.data.success === 2) {
        message.success("Rack creado correctamente - arrástralo y vincúlalo a un pasillo");
        onCreado({
          _id: res.data.rackId,
          mapaAlmacenId,
          codigo: valores.codigo,
          nombre: valores.nombre,
          x: 60,
          y: 60,
          ancho: 70,
          alto: 70,
          numeroColumnas: valores.numeroColumnas,
          numeroNiveles: valores.numeroNiveles,
          numeroProfundidades: valores.numeroProfundidades,
          nodosAccesoIds: [],
          activo: true,
        });
        onClose();
      } else {
        message.error(res.data.error || "No se pudo crear el rack");
      }
    } catch (error) {
      console.error("Error al crear el rack:", error);
      message.error("No se pudo crear el rack");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <ModalItem
      title="Agregar rack"
      visible={visible}
      onCancel={onClose}
      onOk={crear}
      width={520}
      footer
      spinning={guardando}
      confirmLoading={guardando}
    >
      <p style={{ color: "#8a93a6", fontSize: 12 }}>
        Se coloca un cuadrado que puedes arrastrar, redimensionar y pegar junto a otros racks. Para que forme parte de una
        ruta, arrastra una conexión desde cualquiera de sus 4 lados hacia el nodo del pasillo que lo alcance.
      </p>
      <div style={{ marginBottom: 12 }}>
        <div style={{ marginBottom: 4, color: "#6b7280" }}>Código</div>
        <InputItem value={valores.codigo} onChange={(e) => actualizar({ codigo: e.target.value })} />
      </div>
      <div style={{ marginBottom: 12 }}>
        <div style={{ marginBottom: 4, color: "#6b7280" }}>Nombre (opcional)</div>
        <InputItem value={valores.nombre} onChange={(e) => actualizar({ nombre: e.target.value })} />
      </div>
      <div style={{ display: "flex", gap: 8 }}>
        <div style={{ flex: 1 }}>
          <div style={{ marginBottom: 4, color: "#6b7280", fontSize: 12 }}>Columnas</div>
          <InputNumberItem style={{ width: "100%" }} min={1} value={valores.numeroColumnas} onChange={(v) => actualizar({ numeroColumnas: v })} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ marginBottom: 4, color: "#6b7280", fontSize: 12 }}>Niveles</div>
          <InputNumberItem style={{ width: "100%" }} min={1} value={valores.numeroNiveles} onChange={(v) => actualizar({ numeroNiveles: v })} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ marginBottom: 4, color: "#6b7280", fontSize: 12 }}>Profundidades</div>
          <InputNumberItem style={{ width: "100%" }} min={1} value={valores.numeroProfundidades} onChange={(v) => actualizar({ numeroProfundidades: v })} />
        </div>
      </div>
    </ModalItem>
  );
};

export default ModalAgregarRack;
